import React from "react";
import Select from "react-select";

import classes from "./Input.css";

const input = (props) => {
  let inputElement = null;

  const inputClass = [classes.Input];

  if (props.extendedInput) {
    inputClass.push(classes.ExtendedInput);
  }

  if (props.extendedInputClass) {
    inputClass.push(props.extendedInputClass);
  }

  const inputClasses = [classes.InputElement];

  inputClass.push(classes[props.inputType]);

  if (props.inputType === "QuickSearch") {
    inputClasses.push(classes.QuickSearchInput);
  }

  if (props.inputType === "ActivityLogSearch") {
    inputClasses.push(classes.AgentIdInput);
  }

  if (props.invalid && props.shouldValidate && props.touched) {
    inputClasses.push(classes.Invalid);
  }

  if (props.extendedInputClasses) {
    inputClasses.push(props.extendedInputClasses);
  }

  // let validationError = null;
  if (props.invalid && props.validateField) {
    //console.log("[Input] validation error");
    // validationError= <div className={classes.validationError}>Pls enter a valid value!</div>;
  }

  switch (props.elementType) {
    case "input":
      inputElement = (
        <input
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          disabled={props.disabled}
          onChange={props.changed}
          tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        />
      );
      break;
    case "inputPhoneCode":
      inputElement = (
        <div style={{position: "relative", ...(props.elementConfig?.wrapperStyles??{})}}>
          <i className={"fa fa-plus fa-sm"} style={{color:'gray', position:"absolute", left:'4px', top:'8px', transform: 'scale(0.8, 0.8)'}}></i>
          <input
            className={inputClasses.join(" ")}
            {...props.elementConfig}
            value={props.value}
            disabled={props.disabled}
            onChange={props.changed}
            tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
            style = {{textIndent: '8px'}}
          />
        </div>
      );
      break;
    case "inputPhoneCodeNew":
      inputElement = (
        <div style={{position: "relative", ...(props.elementConfig?.wrapperStyles??{})}}>
          <i className={"fa fa-plus fa-sm"} style={{color:'gray', position:"absolute", left:'10%', top:'36%', transform: 'scale(0.8, 0.8)'}}></i>
          <input
            className={inputClasses.join(" ")}
            {...props.elementConfig}
            value={props.value}
            disabled={props.disabled}
            onChange={props.changed}
            tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
            style = {{textIndent: '8px'}}
          />
        </div>
      );
      break;
    case "radio":
      inputElement = (
        <input
          //className={inputClasses.join(' ')}
          type="radio"
          {...props.elementConfig}
          value={props.value}
          disabled={props.disabled}
          onChange={props.changed}
          checked={props.checked}
          tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        />
      );
      break;
    case "checkbox":
      inputElement = (
        <input
          type="checkbox"
          {...props.elementConfig}
          value={props.value}
          disabled={props.disabled}
          onChange={props.changed}
          checked={props.checked}
          tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        />
      );
      break;
    case "inputKeyPress":
      inputElement = (
        <input
          className={inputClasses.join(" ")}
          {...props.elementConfig}
          value={props.value}
          disabled={props.disabled}
          onChange={props.changed}
          onKeyPress={props.onKeyPress}
          tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        />
      );
      break;
    case "textarea":
      inputElement = (
        <textarea
          className={classes.InputElement}
          {...props.elementConfig}
          value={props.value}
          disabled={props.disabled}
          onChange={props.changed}
          tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        />
      );
      break;
    case "select":
      inputElement = (
        <select
          className={classes.InputElement}
          {...props.elementConfig}
          value={props.value}
          disabled={props.disabled}
          onChange={props.changed}
          tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        >
          <option value="" disabled>
            {props.elementConfig.placeholder}
          </option>
          {props.elementConfig.options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={option.disabled}
              className={
                option.highLightedOption ? classes.HighlightedOption : ""
              }
            >
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    case "mobileappselect":
      inputElement = (
        <select
          className={classes.InputElement}
          {...props.elementConfig}
          value={props.value}
          disabled={props.disabled}
          onChange={props.changed}
          tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        >
          <option value="" disabled>
            {props.elementConfig.placeholder}
          </option>
          {props.elementConfig.options.map((option) => (
            <option
              key={option.value}
              value={option.value}
              disabled={
                (props.disableMobApp && option.displayUrl === "mobile app") ||
                option.disabled
              }
              className={
                option.highLightedOption ? classes.HighlightedOption : ""
              }
            >
              {option.displayValue}
            </option>
          ))}
        </select>
      );
      break;
    case "label":
      inputElement = (
        <div>
          <label>{props.key}</label>
          <span>{props.value}</span>
        </div>
      );
      break;

    case "autocompleteselect":
      inputElement = (
        <div className={props.targetPortalCss && classes.targetPortalContainer}>
          <Select
            styles={{
              container: (baseStyles, state)=> ({
                ...baseStyles,
                ...props.targetPortalCss? {width: '100%'}:{},
              }),
              control: (baseStyles, state) => ({
                ...baseStyles,
                margin: 0,
                padding: 0,
                color: "black",
                boxShadow: "1px 1px 0px 0px dimgrey",
                border: "1px solid #ccc",
                fontSize: "medium",
                ...props.targetPortalCss? {width: '100%'}:{},
                height: '28px',
              }),
              menu: (baseStyles, state) => ({
                ...baseStyles,
                width: props.elementConfig.cssProperties.width,
                left: props.elementConfig.cssProperties.left,
              }),
              input: (baseStyles, state) => ({
                ...baseStyles,
                ...props.targetPortalCss? {flexWrap: 'nowrap !important'}:{},
              })
            }}
            placeholder={props.elementConfig.placeholder}
            name={props.elementConfig.id}
            isSearchable
            isDisabled={props.disabled}
            maxMenuHeight={400}
            minMenuHeight={400}
            onChange={props.changed}
            tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
            options={props.elementConfig.options.map((option) => ({
              value: option.value,
              label: option.displayValue,
              disabled: option.disabled,
              disableMobApp: props.disableMobApp,
              displayUrl: option.displayUrl,
              target: { value: option.value },
            }))}
            defaultValue={props.elementConfig.options
              .filter((option) => option.value === props.value)
              .map((option) => ({
                value: option.value,
                label: option.displayValue,
                disabled: option.disabled,
                disableMobApp: props.disableMobApp,
                displayUrl: option.displayUrl,
                target: { value: option.value },
              }))}
            isOptionDisabled={(option) =>
              option.disabled ||
              (option.disableMobApp && option.displayUrl === "mobile app")
            }
          />
        </div>
      );
      break;

    case "autocompleteselectdefault":
        inputElement = (
          <div className={props.targetPortalCss && classes.targetPortalContainer}>
            <Select
              styles={{
                container: (baseStyles, state)=> ({
                  ...baseStyles,
                  ...props.targetPortalCss? {width: '100%'}:{},
                }),
                control: (baseStyles, state) => ({
                  ...baseStyles,
                  margin: 0,
                  padding: 0,
                  color: "black",
                  boxShadow: "1px 1px 0px 0px dimgrey",
                  border: "1px solid #ccc",
                  fontSize: "medium",
                  ...props.targetPortalCss? {width: '100%'}:{},
                  height: '28px',
                }),
                menu: (baseStyles, state) => ({
                  ...baseStyles,
                  width: props.elementConfig.cssProperties.width,
                  left: props.elementConfig.cssProperties.left,
                }),
                input: (baseStyles, state) => ({
                  ...baseStyles,
                  ...props.targetPortalCss? {flexWrap: 'nowrap !important'}:{},
                })
              }}
              placeholder={props.elementConfig.placeholder}
              name={props.elementConfig.id}
              isSearchable
              isDisabled={props.disabled}
              maxMenuHeight={400}
              minMenuHeight={400}
              onChange={props.changed}
              tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
              value={props.value ? props.elementConfig.options
                .filter((option) => option.value == props.value)
                .map((option) => ({
                  value: option.value,
                  label: option.displayValue,
                  disabled: option.disabled,
                  disableMobApp: props.disableMobApp,
                  displayUrl: option.displayUrl,
                  target: { value: option.value },
                })) : null}
              options={
              props.elementConfig.options.map((option) => ({
                value: option.value,
                label: option.displayValue,
                disabled: option.disabled,
                disableMobApp: props.disableMobApp,
                displayUrl: option.displayUrl,
                target: { value: option.value },
              }))}
              isOptionDisabled={(option) =>
                option.disabled ||
                (option.disableMobApp && option.displayUrl === "mobile app")
              }
            />
          </div>
        );
        break;

    case "incidentformhyperlink":
      inputElement = (
        <input
          className={classes.IncidentFormLinkElement}
          value={props.value}
          tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        />
      );
      break;

    default:
      inputElement = (
        <input
          className={classes.InputElement}
          {...props.elementConfig}
          value={props.value}
          tabIndex={props.tabIndex !== undefined ? props.tabIndex : 0}
        />
      );
  }

  return (
    <div className={inputClass.join(" ")}>
      <label className={`${classes.Label} ${props.labelClass}`}>
        <div>{props.label}{props.required && <sup className={classes.required}>*</sup>}</div>
        <div style={{ verticalAlign: "baseline" }}>{props.icon}</div>
      </label>
      {inputElement}
      {/*{validationError}*/}
    </div>
  );
};

export default input;
